module.exports = __webpack_public_path__ + "assets/img/bg-line-driver-52af26cc.png";